<script setup lang="ts">
import {Facebook, Instagram, Linkedin, Youtube} from 'lucide-vue-next';
import {RouterLink} from 'vue-router';
import CompanyLogo from './CompanyLogo.vue';
import {useLanguage} from '../composables/useLanguage';
import {company} from '../config/company';
import {navigationItems} from '../config/navigation';

const {isArabic} = useLanguage();
const year = new Date().getFullYear();
</script>

<template>
  <footer class="site-footer">
    <div class="container footer-grid">
      <div class="footer-brand">
        <CompanyLogo />
        <p>{{ isArabic ? 'شريك موثوق للمقاولات والبنية التحتية والاستثمار العقاري في ليبيا.' : 'A trusted partner for contracting, infrastructure and real estate investment in Libya.' }}</p>
        <div class="footer-socials"><a href="#"><Instagram /></a><a href="#"><Linkedin /></a><a href="#"><Facebook /></a><a href="#"><Youtube /></a></div>
      </div>
      <div>
        <h3>{{ isArabic ? 'روابط سريعة' : 'Quick links' }}</h3>
        <RouterLink v-for="item in navigationItems" :key="item.name" :to="item.path">{{ isArabic ? item.ar : item.en }}</RouterLink>
      </div>
      <div>
        <h3>{{ isArabic ? 'خدماتنا' : 'Services' }}</h3>
        <RouterLink to="/vision">{{ isArabic ? 'رؤيتنا' : 'Company vision' }}</RouterLink>
        <RouterLink to="/about">{{ isArabic ? 'من نحن' : 'About us' }}</RouterLink>
        <RouterLink to="/faq">{{ isArabic ? 'الأسئلة الشائعة' : 'FAQ' }}</RouterLink>
        <RouterLink to="/contact">{{ isArabic ? 'تواصل معنا' : 'Contact us' }}</RouterLink>
      </div>
      <div>
        <h3>{{ isArabic ? 'تواصل' : 'Contact' }}</h3>
        <a :href="`tel:${company.phone.replaceAll(' ', '')}`">{{ company.phone }}</a>
        <a :href="`mailto:${company.email}`">{{ company.email }}</a>
        <p>{{ isArabic ? company.addressAr : company.addressEn }}</p>
      </div>
    </div>
    <div class="container footer-bottom">
      <span>© {{ year }} {{ isArabic ? company.shortNameAr : company.nameEn }}</span>
      <span>{{ isArabic ? 'جميع الحقوق محفوظة' : 'All rights reserved' }}</span>
    </div>
  </footer>
</template>
